export default __webpack_public_path__ + "static/media/softclix_lancing_kit@3x.d0ce2378.webp";